document.addEventListener('DOMContentLoaded', () => {
    // Remove empty paragraphs
    document.querySelectorAll('.description p').forEach(p => {
        if (p.innerHTML.trim() === '&nbsp;' || p.innerHTML.trim() === '' || p.textContent.trim() === '') {
            p.remove();
        }
    });

    const descriptions = document.querySelectorAll('.description');
    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
    const getCharacterLimit = () => (isMobile() ? 200 : 290);
    const LINE_LIMIT = 3;

    const BLOCK_TAGS = new Set(['P', 'DIV', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'UL', 'OL', 'LI', 'BLOCKQUOTE', 'PRE', 'SECTION', 'ARTICLE', 'HEADER', 'FOOTER', 'ADDRESS', 'FIGURE', 'FIGCAPTION']);

    const getBlockLineCount = (container) => {
        return Array.from(container.children).filter((el) => BLOCK_TAGS.has(el.tagName)).length;
    };

    const truncateHTMLByLines = (html, maxLines) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        const blockChildren = Array.from(div.children).filter((el) => BLOCK_TAGS.has(el.tagName));
        if (blockChildren.length <= maxLines) return null;
        return blockChildren.slice(0, maxLines).map((el) => el.outerHTML).join('');
    };

    // Function to truncate HTML while preserving structure
    const truncateHTML = (element, maxLength) => {
        const clone = element.cloneNode(true);
        let charCount = 0;
        let truncateAtNode = null;
        let truncateAtIndex = -1;
        let truncateAtParent = null;
        
        const walker = document.createTreeWalker(
            clone,
            NodeFilter.SHOW_TEXT,
            null,
            false
        );
        
        // Find the truncation point
        let node;
        while (node = walker.nextNode()) {
            const text = node.textContent;
            if (charCount + text.length > maxLength) {
                // Find word boundary
                const remaining = maxLength - charCount;
                let truncateAt = remaining;
                
                // Try to break at word boundary (within reasonable distance)
                while (truncateAt > 0 && 
                       text[truncateAt] !== ' ' && 
                       text[truncateAt] !== '\n' && 
                       text[truncateAt] !== '.' &&
                       truncateAt > remaining - 50) {
                    truncateAt--;
                }
                
                if (truncateAt === 0) truncateAt = remaining;
                
                // Truncate this text node
                node.textContent = text.substring(0, truncateAt);
                truncateAtNode = node;
                truncateAtParent = node.parentNode;
                
                // Find the index of this node in its parent
                if (truncateAtParent) {
                    const siblings = Array.from(truncateAtParent.childNodes);
                    truncateAtIndex = siblings.indexOf(node);
                }
                break;
            }
            charCount += text.length;
        }
        
        // Remove all nodes after the truncation point
        if (truncateAtNode && truncateAtParent && truncateAtIndex >= 0) {
            const siblings = Array.from(truncateAtParent.childNodes);
            
            // Remove all siblings after the truncation point
            for (let i = truncateAtIndex + 1; i < siblings.length; i++) {
                const sibling = siblings[i];
                if (sibling && sibling.parentNode) {
                    sibling.parentNode.removeChild(sibling);
                }
            }
            
            // Recursively remove all nodes in parent elements that come after truncation
            const removeAfterTruncation = (parent) => {
                if (!parent || parent === clone) return;
                
                const parentSiblings = Array.from(parent.parentNode?.childNodes || []);
                const parentIndex = parentSiblings.indexOf(parent);
                
                if (parentIndex >= 0) {
                    // Remove all siblings after this parent
                    for (let i = parentIndex + 1; i < parentSiblings.length; i++) {
                        const sibling = parentSiblings[i];
                        if (sibling && sibling.parentNode) {
                            sibling.parentNode.removeChild(sibling);
                        }
                    }
                }
                
                removeAfterTruncation(parent.parentNode);
            };
            
            removeAfterTruncation(truncateAtParent);
        }
        
        // Clean up empty elements
        const allElements = Array.from(clone.querySelectorAll('*'));
        allElements.reverse().forEach(el => {
            if (el.textContent.trim() === '' && el.children.length === 0 && el !== clone) {
                el.remove();
            }
        });
        
        return clone.innerHTML;
    };

    descriptions.forEach((description) => {
        // Store original HTML first
        const originalHTML = description.innerHTML;
        
        // Remove existing read more/less links and fade elements from original
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = originalHTML;
        const readMoreLink = tempDiv.querySelector('.readMoreLink');
        const readLessLink = tempDiv.querySelector('.readLessLink');
        const fade = tempDiv.querySelector('.fade');
        
        if (readMoreLink) readMoreLink.remove();
        if (readLessLink) readLessLink.remove();
        if (fade) fade.remove();
        
        const cleanOriginalHTML = tempDiv.innerHTML;
        
        // Get plain text for length calculation from cleaned HTML
        const tempForText = document.createElement('div');
        tempForText.innerHTML = cleanOriginalHTML;
        const fullText = (tempForText.textContent || tempForText.innerText || '').trim();
        
        // Count top-level "lines" (block elements only, e.g. <p> tags; not <br> or inline)
        const lineCount = getBlockLineCount(tempDiv);
        const characterLimit = getCharacterLimit();
        const overCharacterLimit = fullText.length > characterLimit;
        const overLineLimit = lineCount > LINE_LIMIT;
        const needTruncation = overCharacterLimit || overLineLimit;

        if (needTruncation) {
            let truncatedHTML = null;

            if (overLineLimit) {
                // Truncate to first N lines (e.g. first 3 paragraphs)
                truncatedHTML = truncateHTMLByLines(cleanOriginalHTML, LINE_LIMIT);
            }
            if (truncatedHTML === null && overCharacterLimit) {
                // Truncate by character limit while preserving structure
                const tempElement = document.createElement('div');
                tempElement.innerHTML = cleanOriginalHTML;
                truncatedHTML = truncateHTML(tempElement, characterLimit);
            }

            if (truncatedHTML) {
                // Verify character-based truncation actually shortened (line truncation is always valid)
                const verifyDiv = document.createElement('div');
                verifyDiv.innerHTML = truncatedHTML;
                const truncatedText = (verifyDiv.textContent || verifyDiv.innerText || '').trim();
                const didTruncate = overLineLimit || (truncatedText.length < fullText.length && truncatedText.length > 0);

                if (didTruncate) {
                    description.setAttribute('data-full-content', cleanOriginalHTML);
                    description.setAttribute('data-truncated-content', truncatedHTML);
                    description.innerHTML = truncatedHTML;

                    const toggleSpan = document.createElement('span');
                    toggleSpan.className = 'read-more-toggle';
                    toggleSpan.textContent = 'Read more';
                    toggleSpan.style.display = 'inline';
                    // If there's a <p> inside (e.g. div > p), put "Read more" inside the last p so it sits after the text
                    const paragraphs = description.querySelectorAll('p');
                    const lastP = paragraphs.length > 0 ? paragraphs[paragraphs.length - 1] : null;
                    if (lastP) {
                        lastP.appendChild(toggleSpan);
                    } else {
                        description.appendChild(toggleSpan);
                    }
                } else {
                    description.innerHTML = cleanOriginalHTML;
                }
            } else {
                description.innerHTML = cleanOriginalHTML;
            }
        } else {
            description.innerHTML = cleanOriginalHTML;
        }
    });
    
    // Use event delegation on description elements for toggle clicks
    descriptions.forEach((description) => {
        description.addEventListener('click', function(event) {
            // Check if the clicked element is a read-more-toggle
            if (event.target.classList.contains('read-more-toggle')) {
                event.preventDefault();
                const toggle = event.target;
                const fullContentHTML = description.getAttribute('data-full-content');
                const truncatedContentHTML = description.getAttribute('data-truncated-content');
                
                if (!fullContentHTML || !truncatedContentHTML) return;
                
                if (toggle.textContent.trim() === 'Read more') {
                    // Expand: Replace content with full content wrapped in span, toggle as sibling
                    const fullContentSpan = document.createElement('span');
                    fullContentSpan.className = 'full-content';
                    fullContentSpan.innerHTML = fullContentHTML;
                    
                    // Remove old toggle
                    toggle.remove();
                    
                    // Create new toggle as sibling
                    const newToggle = document.createElement('span');
                    newToggle.className = 'read-more-toggle';
                    newToggle.textContent = ' Read less';
                    newToggle.style.display = 'inline';
                    
                    // Replace description content
                    description.innerHTML = '';
                    description.appendChild(fullContentSpan);
                    description.appendChild(newToggle);
                } else {
                    // Collapse: Remove old toggle first
                    toggle.remove();
                    
                    // Replace with truncated content
                    description.innerHTML = truncatedContentHTML;

                    const newToggle = document.createElement('span');
                    newToggle.className = 'read-more-toggle';
                    newToggle.textContent = 'Read more';
                    newToggle.style.display = 'inline';
                    const paragraphs = description.querySelectorAll('p');
                    const lastP = paragraphs.length > 0 ? paragraphs[paragraphs.length - 1] : null;
                    if (lastP) {
                        lastP.appendChild(newToggle);
                    } else {
                        description.appendChild(newToggle);
                    }
                }
            }
        });
    });
});